import {
  ArrowRightOutlined,
  PrinterOutlined,
  UserSwitchOutlined
} from '@ant-design/icons';
import React, { useContext, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Table, Tag } from 'antd';
import { SorterResult } from 'antd/lib/table/interface';
import { sortOrderType } from 'common/utils';
import { rootContext } from 'stores';
import { ITransactionInfo, ItransactionType } from 'types';
import dayjs from 'dayjs';

export type UsertransactiontableProps = {
  id: string;
};
const Usertransactiontable: React.FC<UsertransactiontableProps> = observer(
  ({ id }) => {
    const {
      UsersStore: {
        getUserCreditHistory,
        setState,
        state: {
          data: { userDetail, userDetailParams },
          data
        }
      }
    } = useContext(rootContext);
    const { limit, offset } = userDetailParams;

    useEffect(() => {
      getUserCreditHistory({ userId: id, ...userDetailParams });
    }, [getUserCreditHistory, id, setState, userDetailParams]);

    const onChange = (pagination: any, _: any, sort: any) => {
      const sortInfo = sort as SorterResult<ITransactionInfo>;

      setState({
        data: {
          ...data,
          userDetailParams: {
            ...userDetailParams,
            limit: pagination.pageSize || userDetailParams.limit,
            offset: ((pagination.current || 1) - 1) * pagination.pageSize,
            ...(sortInfo?.columnKey ? { sortField: sortInfo.columnKey } : {}),
            sortBy: sortInfo?.order ? sortOrderType(sortInfo.order) : null
          }
        }
      });
    };

    return (
      <Table<ITransactionInfo>
        rowKey="id"
        title={() => 'Transactions'}
        className="Table_block_main"
        dataSource={userDetail.credit_history || []}
        rowClassName={t => t.type}
        pagination={{
          current: Number((offset / limit).toFixed(0)) + 1,
          pageSize: limit,
          total: userDetail.credit_total_count,
          showSizeChanger: true,
          pageSizeOptions: ['10', '15', '20']
        }}
        onChange={onChange}
        columns={[
          {
            title: 'from',
            align: 'center',
            dataIndex: ['from', 'username'],
            key: 'from'
          },
          {
            title: 'to',
            align: 'center',
            dataIndex: ['to', 'username'],
            key: 'from'
          },
          {
            title: 'Type',
            dataIndex: 'type',
            align: 'center',
            key: 'type',
            render: (v: ItransactionType, record) => (
              <Tag color={v === 'CREDITED' ? 'green' : 'red'}>{v}</Tag>
            ),
            sorter: false
          },
          {
            title: 'Amount',
            dataIndex: 'amount',
            align: 'center',
            key: 'amount',
            render: value => Number(value)?.toFixed(2),
            sorter: true
          },
          {
            title: 'Time',
            dataIndex: 'createdAt',
            key: 'createdAt',
            align: 'center',
            sorter: true,
            render: value => dayjs(value).format('DD/MM/YYYY HH:mm')
          },
          {
            title: 'Credit',
            key: 'credit',
            align: 'center',
            render: (val, record) => (
              <>
                {record.old_credit} <ArrowRightOutlined /> {record.new_credit}
              </>
            )
          },
          {
            title: 'Cause',
            align: 'center',
            dataIndex: 'print_record',
            key: 'print_record',
            sorter: false,
            render: (v, r) =>
              r.print_record ? (
                <>
                  <PrinterOutlined />
                  {' Print'}
                </>
              ) : (
                <>
                  <UserSwitchOutlined />
                  {' Transfer'}
                </>
              )
          }
        ]}
      />
    );
  }
);

export default Usertransactiontable;
